import { Phone } from "lucide-react"
import { Button } from "./button"
import { useEmergencyPhoneNumber } from "../../hooks/use-emergency-service"
import { useEffect, useState } from "react"


export const EmergencyServicesButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isError, setIsError] = useState<boolean>(false)
  const { sharedNumber, policeNumber, ambulanceNumber, fireNumber, error } = useEmergencyPhoneNumber()

  const handleCall = () => {
    if (sharedNumber) {
      return window.location.href = `tel:${sharedNumber}`
    }
    else {
      setIsOpen(true)
    }
  }
  useEffect(() => {
    setIsError(!!error)
  }, [error])

  return (
    <>
    {isOpen && 
    <div className="absolute top-0 left-0 w-full h-full bg-black/50 z-50" onClick={() => setIsOpen(false)}>
      <div className="absolute top-1/2 left-1/2 flex flex-col gap-2 bg-white rounded-2xl p-4 transform -translate-x-1/2 -translate-y-1/2">
        {ambulanceNumber && <Button className="w-64" variant="secondary" onClick={() => window.location.href = `tel:${ambulanceNumber}`}>{ambulanceNumber}<Phone className="w-6 h-6 text-primary-white"  /></Button> }
        {fireNumber && <Button className="w-64" variant="secondary" onClick={() => window.location.href = `tel:${fireNumber}`}>{fireNumber}<Phone className="w-6 h-6 text-primary-white"  /></Button> }
        {policeNumber && <Button className="w-64" variant="secondary" onClick={() => window.location.href = `tel:${policeNumber}`}>{policeNumber}<Phone className="w-6 h-6 text-primary-white"  /></Button> }
      </div>
    </div>
    }

      <Button
        onClick={handleCall}
        disabled={isError}
        className="h-16 flex-row items-center rounded-2xl justify-center w-full bg-danger-primary"
      >
        {error ? 
         <p className="text-primary-white">{error?.toString()} </p> :
        <>
          <p className="text-primary-white text-xl font-semibold">
            Emergency services
          </p>
          <Phone className="w-6 h-6 text-primary-white"  />
        </>
        }
      </Button>
    </>
  )
}
